import currencyFormatter from 'currency-formatter';
export const formatCurrency = (amount: number, currencyCode: string) => {
    return currencyFormatter.format(amount, { code: currencyCode });
}